export class Configuration {
  BASE_URL = '';
  CDN_BASE_URL = '';
  SFTP_URL = '';
  AUTH_KEY: string = 'authDetail';

  constructor(public state: projectState) {
    if (this.state == 'staging') {
      this.BASE_URL = 'https://rr-dev-apis.riskrelease.com/';
      this.SFTP_URL = 'https://qa-manager-upload.riskrelease.com/auth/login';
    } else if (this.state == 'qa') {
      this.BASE_URL = 'https://qa-apis.riskrelease.com/';
      this.CDN_BASE_URL = 'https://d39e2ae2iczbh9.cloudfront.net/';
      this.SFTP_URL = 'https://qa-manager-upload.riskrelease.com/auth/login';
    } else if (this.state == 'production') {
      this.BASE_URL = 'https://prod-apis.riskrelease.com/';
      this.CDN_BASE_URL = 'https://d3tq5ae16iqksu.cloudfront.net/';
      this.SFTP_URL = 'https://prod-manager-upload.riskrelease.com/auth/login';
    } else if (this.state == 'preprod') {
      this.BASE_URL = 'https://preprod-apis.riskrelease.com/';
      this.CDN_BASE_URL = 'https://d385px9as2cq0e.cloudfront.net/';
      this.SFTP_URL = 'https://qa-manager-upload.riskrelease.com/auth/login';
    } else if (this.state == 'local') {
      this.BASE_URL = 'http://192.168.21.142:5102/';
      this.SFTP_URL = 'https://qa-manager-upload.riskrelease.com/auth/login';
    } else {
      this.BASE_URL = 'https://demo-apis.riskrelease.com/';
      this.SFTP_URL = 'https://qa-manager-upload.riskrelease.com/auth/login';
    }
  }
}
type projectState = 'staging' | 'production' | 'qa' | 'preprod' | 'local';
export const configuration = new Configuration('qa');
